import { triniumApi } from '@api/Trinium/slice';
import { Service } from './types';

/**
 * Endpoint for returning all servies, contrast with the /jobcategories/{id}/services which
 * returns services related to a given jobCategory.  This is initially used by reports that need to
 * report on serices across multiple job categories.
 */
export const serviceSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchAllServices: builder.query<
				Service[],
				{
					terminalNumber: string;
					nameStartsWith?: string;
				}
			>({
				query: ({ terminalNumber, nameStartsWith }) => ({
					url: `/${terminalNumber}/reports/services`,
					params: {
						nameStartsWith
					}
				})
			})
		};
	}
});

export const { useLazyFetchAllServicesQuery, useFetchAllServicesQuery } = serviceSlice;
